import React,{ useContext } from "react";
import "../css/landing.css";
import Course from "./Landing/Landing";
import Mycourses from "./Learner/Mycourses";
import { UserContext } from "../context/UserContext";
import Signin from "./Signin";

// class Home extends Component {
  const Home = () => {
    const context = useContext(UserContext);
    return (
      <div>
       
        {context.user?.email ?  <Mycourses/>:<Signin/>}
      </div>
    );
  }

export default Home;
